var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eIeu86RWkg41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 18,
    height: 18,
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.7,4.1c1.8-1.8,4.7-1.8,6.4,0c1.7,1.7,1.7,4.4,0,6.5L8.9,14.4L5.7,10.6C4,8.5,4,5.8,5.7,4.1Zm-.6,7l3.5,4.2c.2.2.4.2.6.1c0,0,0,0,.1-.1l3.5-4.2c.9-1.1,1.4-2.4,1.5-3.8c0-1.4-.5-2.8-1.5-3.8-2.1-2.1-5.5-2.1-7.6,0-1,1-1.5,2.4-1.5,3.8s.5,2.7,1.4,3.8ZM8.9,5.5c-1,0-1.8.8-1.8,1.8s.9,1.7,1.8,1.7s1.8-.8,1.8-1.8c0-.9-.8-1.7-1.8-1.7Zm0,4.4c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6-2.6,1.1-2.6,2.6c0,1.4,1.2,2.6,2.6,2.6Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit);
export default __webpack_public_path__ + "static/media/Unit.dfac6e502004921ca4cfdb6ce85fec75.svg";
export { ForwardRef as ReactComponent };